window.BAO.ProductForm = class ProductForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.smartrr = new Smartrr(this.form)
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    window.setTimeout(() => {
      super.checkValidity()

      if (!this.form) {
        this.throwError(`needs to be wrapped around a product's <form> element`)
      }
    }, 500)
  }

  async onSubmitHandler (e) {
    e.preventDefault()
    await this.addToCart()
    if (window.location.pathname === `/cart`) {
      window.location.reload()
    }
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

class Smartrr {
  constructor (form) {
    this.form = form
    this.initialise()
  }

  initialise () {
    if (!this.purchaseOptionsEl) return
    this.updateSmartrrOptionLabels()
    this.showSmartrrMessage()
  }

  updateSmartrrOptionLabels () {
    if (
      !this.deliveryFrequencyEl ||
      !this.sellingPlanSelectLabelInputEls.length
    ) {
      return
    }
    this.sellingPlanSelectLabelInputEls.forEach(
      sellingPlanSelectLabelInputEl => {
        sellingPlanSelectLabelInputEl.textContent = `${this.deliveryFrequencyEl.textContent} ${sellingPlanSelectLabelInputEl.textContent}`
      },
    )
  }

  showSmartrrMessage () {
    if (!this.messageEl || !this.sellingPlanGroupEls.length) return
    const lastSellingPlanGroupEl = this.sellingPlanGroupEls?.[
      this.sellingPlanGroupEls.length - 1
    ]
    const sellingPlanGroupContentsEl = lastSellingPlanGroupEl?.querySelector(
      this.selectors.sellingPlanGroupContentsEl,
    )
    if (lastSellingPlanGroupEl && sellingPlanGroupContentsEl) {
      lastSellingPlanGroupEl.insertBefore(
        this.messageEl,
        sellingPlanGroupContentsEl,
      )
    }
  }

  get selectors () {
    return {
      purchaseOptionsEl: `.smartrr-purchase-options`,
      deliveryFrequencyEl: `.smartrr-deliver-frequency`,
      sellingPlanSelectLabelInputEl: `[data-smartrr-selling-plan-select-label-input]`,
      messageTemplateEl: `[data-smartrr-message]`,
      sellingPlanGroupEl: `[data-smartrr-selling-plan-group-id]`,
      sellingPlanGroupContentsEl: `[data-smartrr-selling-plan-group-contents]`,
    }
  }

  get purchaseOptionsEl () {
    return this.form.querySelector(this.selectors.purchaseOptionsEl)
  }

  get deliveryFrequencyEl () {
    return this.form.querySelector(this.selectors.deliveryFrequencyEl)
  }

  get sellingPlanSelectLabelInputEls () {
    return this.form.querySelectorAll(
      this.selectors.sellingPlanSelectLabelInputEl,
    )
  }

  get messageEl () {
    const messageTemplateEl = this.form.querySelector(
      this.selectors.messageTemplateEl,
    )
    if (!messageTemplateEl) return
    return messageTemplateEl.content.cloneNode(true)
  }

  get sellingPlanGroupEls () {
    return this.form.querySelectorAll(this.selectors.sellingPlanGroupEl)
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', window.BAO.ProductForm)
}
